import { gql } from 'apollo-angular';

export const RETURN_LIST_FIELDS = gql`
  fragment ReturnListFields on object_Returns {
    id
    firstName
    lastName
    refundType
    requestTime
    status
    orderNumber
    creationDate
    origin
  }
`;

export const RETURN_FIELDS = gql`
  fragment ReturnFields on object_Returns {
    id
    firstName
    lastName
    email
    phone
    address
    city
    zipCode
    province
    country
    refundType
    requestTime
    status
    closureDate
    orderNumber
    origin
    receivedInStoreAt
    shippedToLogisticAt
    deliveredInLogisticAt
    keptInStoreAt
    refunds {
      ... on object_Refund {
        totalAmount
      }
    }
  }
`;
